module.exports = __webpack_public_path__ + "static/media/referral-program-3.e212d1dc.jpg";